// ¿Paso a paso o /admin/devices? (CC-CONSOLE#1561)
//
// Quien va a vincular su PRIMER equipo (la compañía no tiene dispositivos
// reales; los de ejemplo del Sandbox, `demoSeed: true`, no cuentan) entra al
// paso a paso de `/dispositivos/vincular`. Quien ya tiene al menos uno va a
// `/admin/devices` con el alta abierta (`?vincular=1`): ahí ve sus equipos y
// vincula el siguiente con la misma información.
//
// El conteo sale de `GET /sandbox` (`realCounts.devices`). Sin respuesta, o con
// una API anterior que no lo manda, se queda en el paso a paso: funciona para
// cualquiera y no esconde nada.

import { useSandboxStore } from "../sandbox/sandboxStore";
import { DEVICE_LINK_PATH } from "../../utils/nextPath";

export const ADMIN_DEVICES_PATH = "/admin/devices";
/** Abre el alta de /admin/devices al llegar. */
export const ADMIN_LINK_PARAM = "vincular";
/** Fuerza el paso a paso aunque ya haya equipos. */
export const FORCE_WIZARD_PARAM = "forzar";

const langOf = (value: string | null | undefined): "es" | "en" | null =>
  value === "es" || value === "en" ? value : null;

/**
 * El destino para `realDevices` equipos reales. `wizardPath` es la ruta del
 * paso a paso con su query (p. ej. `/dispositivos/vincular?back=/bienvenida`).
 */
export function deviceLinkDestination(
  realDevices: number | null,
  { wizardPath = DEVICE_LINK_PATH, lang = null }: { wizardPath?: string; lang?: string | null } = {},
): string {
  const query = new URLSearchParams(wizardPath.includes("?") ? wizardPath.slice(wizardPath.indexOf("?") + 1) : "");
  if (query.get(FORCE_WIZARD_PARAM) === "1") return wizardPath;
  if (realDevices === null || realDevices < 1) return wizardPath;
  const params = new URLSearchParams({ [ADMIN_LINK_PARAM]: "1" });
  const finalLang = langOf(lang) ?? langOf(query.get("lang"));
  if (finalLang) params.set("lang", finalLang);
  return `${ADMIN_DEVICES_PATH}?${params.toString()}`;
}

/** Equipos reales de la compañía de la sesión, o null si no se sabe. Nunca lanza. */
export async function fetchRealDeviceCount(): Promise<number | null> {
  try {
    await useSandboxStore.getState().load({ force: true });
    const counts = useSandboxStore.getState().realCounts;
    return counts ? counts.devices : null;
  } catch {
    return null;
  }
}

/** Consulta el conteo y devuelve el destino. Nunca lanza. */
export async function resolveDeviceLinkDestination(opts: { wizardPath?: string; lang?: string | null } = {}): Promise<string> {
  const query = opts.wizardPath?.includes("?") ? new URLSearchParams(opts.wizardPath.slice(opts.wizardPath.indexOf("?") + 1)) : null;
  if (query?.get(FORCE_WIZARD_PARAM) === "1") return opts.wizardPath ?? DEVICE_LINK_PATH;
  return deviceLinkDestination(await fetchRealDeviceCount(), opts);
}
